module.exports = __webpack_public_path__ + "img/product_vision_description.7cf4f166.png";